import { render, staticRenderFns } from "./OneOffSummary.vue?vue&type=template&id=458a8052&"
import script from "./OneOffSummary.vue?vue&type=script&lang=js&"
export * from "./OneOffSummary.vue?vue&type=script&lang=js&"
import style0 from "./OneOffSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports